<template>
  <div class="conversation-list-container">
    <h2 class="conversation-list-count" :class="$dm('text-slate-700', 'dark:text-slate-300')"
      @click="onOpenHeaderClick">
      <fluent-icon class="mr-2" size="16" icon="chevron-right" v-if="!openConversationsIsOpen" />
      <fluent-icon class="mr-2" size="16" icon="chevron-down" v-if="openConversationsIsOpen" />
      Open&nbsp;<span v-if="openConversationItems">({{ openConversationItemsCount }})</span>
    </h2>
    <ConversationList status="open" :isOpen="openConversationsIsOpen" />
    <h2 class="conversation-list-count" :class="$dm('text-slate-700', 'dark:text-slate-300')"
      @click="onClosedHeaderClick">
      <fluent-icon class="mr-2" size="16" icon="chevron-right" v-if="!closedConversationsIsOpen" />
      <fluent-icon class="mr-2" size="16" icon="chevron-down" v-if="closedConversationsIsOpen" />
      Closed&nbsp;<span v-if="closedConversationItems">({{ closedConversationItemsCount }})</span>
    </h2>
    <ConversationList status="closed" :isOpen="closedConversationsIsOpen" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import FluentIcon from 'widget/components/FluentIcon/Index.vue';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';

import ConversationList from "./ConversationList.vue";

export default {
  name: "ConversationListWrap",
  components: { ConversationList, FluentIcon },
  mixins: [darkModeMixin],
  computed: {
    ...mapGetters({
      openConversationItems: 'openConversationList/getConversations',
      openConversationItemsCount: 'openConversationList/getConversationCount',
      closedConversationItems: 'closedConversationList/getConversations',
      closedConversationItemsCount: 'closedConversationList/getConversationCount',
    }),
  },
  data() {
    return {
      openConversationsIsOpen: true,
      closedConversationsIsOpen: true,
    };
  },
  methods: {
    onOpenHeaderClick() {
      this.openConversationsIsOpen = !this.openConversationsIsOpen;
    },
    onClosedHeaderClick() {
      this.closedConversationsIsOpen = !this.closedConversationsIsOpen;
    },
  },
};
</script>

<style scoped lang="scss">
@import "widget/assets/scss/helpers/variables.scss";

.conversation-list-container {
  width: 100%;
  padding: 0 1rem 0 1rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .conversation-list-count {
    font-weight: 600;
    font-size: 0.9rem;
    padding: 0.5rem;
    margin: 1.0rem 0 0.5rem 0;
    display: flex;
    cursor: pointer;
    align-items: center;
  }
}
</style>
